import type { Theme } from '@mui/material';

import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Divider, TextField, Typography, Autocomplete, useMediaQuery } from '@mui/material';

import { anonymous_citiesFunc } from 'src/context/cities/anonymous_cities';

interface ICitiesItemProps {
  name: string;
  districts: string[];
}

export const CityFilter = (props: { filters: any; setFilters: React.Dispatch<any> }) => {
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const cities = useSelector((state: any) => state.anonymous_cities);
  const [citiesData, setCitiesData] = useState([] as ICitiesItemProps[]);
  const [selectedCity, setSelectedCity] = useState<ICitiesItemProps | undefined>(undefined);
  const [selectedDistricts, setSelectedDistricts] = useState<string>('');
  const districtData = selectedCity?.districts || [];
  const [searchParams] = useSearchParams();
  const city = searchParams.get('sehir') || null;
  const district = searchParams.get('ilce') || null;

  useEffect(() => {
    if (dispatch) {
      dispatch(anonymous_citiesFunc());
    }
  }, [dispatch]);

  useEffect(() => {
    const anonymousCitiesData = cities?.anonymous_citiesData?.data;

    setCitiesData(anonymousCitiesData);
  }, [cities]);

  useEffect(() => {
    setSelectedDistricts('');
  }, [selectedCity]);

  useEffect(() => {
    if (city) {
      const foundCity = citiesData?.find((c) => c.name === city);
      setSelectedCity(foundCity);
    }
  }, [city, citiesData]);

  useEffect(() => {
    if (district) {
      const foundDistrict = districtData?.find((d) => d === district);
      setSelectedDistricts(foundDistrict || '');
    }
  }, [district, districtData]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Konum
      </Typography>

      <Autocomplete
        id="city-search-input"
        key={selectedCity?.name}
        clearIcon={null}
        disableClearable={false}
        options={citiesData}
        value={selectedCity}
        getOptionLabel={(option) => option?.name || ''}
        renderInput={(params) => (
          <TextField
            {...params}
            label="İl"
            slotProps={{
              input: {
                ...params.InputProps,
                type: 'search',
              },
            }}
            size="small"
            sx={{
              mb: 1,
              '& .MuiInputBase-root': {
                borderRadius: '100px',
              },
              '& .MuiInputBase-input': {
                fontSize: 12,
              },
            }}
          />
        )}
        onChange={(event, newValue) => {
          setSelectedCity(newValue || undefined);
          props.setFilters((prev: any) => ({
            ...prev,
            location: {
              ...prev.location,
              city: newValue?.name || null,
              district: null,
            },
          }));
        }}
      />

      <Autocomplete
        id="district-search-input"
        clearIcon={null}
        disableClearable={false}
        options={districtData ?? []}
        value={selectedDistricts}
        getOptionLabel={(option) => option || ''}
        renderInput={(params) => (
          <TextField
            {...params}
            label="İlçe"
            slotProps={{
              input: {
                ...params.InputProps,
                type: 'search',
              },
            }}
            size="small"
            sx={{
              mb: 1,
              '& .MuiInputBase-root': {
                borderRadius: '100px',
              },
              '& .MuiInputBase-input': {
                fontSize: 12,
              },
            }}
          />
        )}
        onChange={(event, newValue) => {
          setSelectedDistricts(newValue || '');
          props.setFilters((prev: any) => ({
            ...prev,
            location: {
              ...prev.location,
              city: selectedCity?.name || null,
              district: newValue || null,
            },
          }));
        }}
      />
    </Box>
  );
};
